import type { Configuration, RedirectRequest, SilentRequest } from '@azure/msal-browser'
import { BrowserCacheLocation, LogLevel } from '@azure/msal-browser'

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string
const apiScope = import.meta.env.VITE_ENTRA_API_SCOPE as string

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback(level, message, containsPii) {
        if (containsPii) return
        if (import.meta.env.DEV) {
          switch (level) {
            case LogLevel.Error:
              console.error('[MSAL]', message)
              break
            case LogLevel.Warning:
              console.warn('[MSAL]', message)
              break
          }
        }
      }
    }
  }
}

export const entraLoginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email', apiScope]
}

export const entraTokenRequest: SilentRequest = {
  scopes: [apiScope],
  account: undefined
}
